// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","vaccination__subtitle":"VaccinationDescriptions_vaccination__subtitle__3laBF","vaccination__list":"VaccinationDescriptions_vaccination__list__a9K+r"};